import { FatalDecoratorLimitDescriptorError } from '@rehaje/reactive'
import {
  createMemberDecorator,
  ensureProtoProps,
  isInheritProto
} from '@rehaje/shared'

import { TypedNode } from '../models/TypedNode'

import type { MixtureMemberDecorator } from '@rehaje/shared'

/**
 * 惰性同步
 * @example
 * // jsdoc 限制，实际使用请将 * 替换为 @
 * class MyNode extends TypedNode {
 *   *lazy()
 *   *fromSpecific()
 *   test = 123
 * }
 */
export const lazy: () => MixtureMemberDecorator = createMemberDecorator({
  tsDecorator(proto: TypedNode, key, descriptor) {
    if (!isInheritProto(proto, TypedNode.prototype)) {
      throw new FatalDecoratorLimitDescriptorError('lazy', key, 'TypedNode')
    }

    const lazyMaps = ensureProtoProps(proto, '__r_lazy_maps', {})
    lazyMaps[key] = true

    return descriptor
  }
})
